<template>
  <div class="content">
    <div class="table-responsive">
      <table class="table table-hover table-clean table-vcenter" style="width:100%;">
        <thead>
          <tr>
            <th width="5%" class="text-nowrap">ID</th>
            <th width="15%" class="text-nowrap">{{ $t('name') }}</th>
            <th width="10%" class="text-nowrap">{{ $t('checkIn') }}</th>
            <th width="10%" class="text-nowrap">{{ $t('checkOut') }}</th>
            <th width="5%" class="text-nowrap">{{ $t('nights') }}</th>
            <th width="15%" class="text-nowrap">{{ $t('room') }}</th>
            <th width="5%" class="text-nowrap">{{ $t('unit') }}</th>
            <th width="5%" class="text-nowrap">{{ $t('guests') }}</th>
            <th width="10%" class="text-nowrap">{{ $t('referer') }}</th>
            <th width="10%" class="text-nowrap">{{ $t('status') }}</th>
            <th width="10%" class="text-nowrap">{{ $t('created') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr role="button" v-for="booking in pagination.bookings" @click="booking.status == '0' || $router.push('/' + $i18n.locale + '/' + $t('bookings') + '/' + booking._id)" v-bind:class="{'table-active disabled': booking.status == '0'}">
            <td>{{booking.index}}</td>
            <td>{{booking.payer.name.first}} {{booking.payer.name.last}}</td>
            <td>{{booking.night.first | date}}</td>
            <td>{{booking.night.last | checkOut}}</td>
            <td>{{ dayDiff(booking.night.first, booking.night.last) }}</td>
            <td>
              {{ booking.room.name }}
            </td>
            <td v-if="booking.unit">{{ booking.unit.name }}</td>
            <td v-else></td>
            <td>{{booking.guests.length}} / {{booking.numGuests.adults + booking.numGuests.children}}</td>
            <td>
              <span v-if="booking.referer">
                {{booking.referer.channel}}
              </span>
            </td>

            <td v-if="booking.payer.phone.error">Phone Error</td>
            <td v-else-if="booking.status == '0'">Canceled</td>
            <td v-else-if="booking.status == '1' || booking.status == '2'">
              <span v-if="booking.guests.length < booking.numGuests.adults + booking.numGuests.children">Not Completed</span>
              <span v-else-if="booking.guests.find(g => !g.index)">Not Reported</span>
              <span v-else>Confirmed</span>
            </td>
            <td v-else>Request</td>


            <td>{{booking.created | date}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="dataTables_wrapper">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" id="dt-basic_info" role="status" aria-live="polite">
            {{ $t('showing') }}
            {{ pagination.first }}
            <span v-if="pagination.bookings.length">
              {{ $t('to') }} {{ pagination.first + pagination.bookings.length - 1 }}
            </span>
            {{ $t('of') }}
            {{ pagination.total }}
            {{ $t('entries') }}
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <pagination v-bind:pages="pagination.pages"></pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Pagination from '../../pagination/Pagination.vue';
import CheckIn from '../../filters/CheckIn.vue';

import moment from 'moment';

export default {
  name: 'BookingsList',
  components:{
    Pagination
  },
  filters: {
    date: function(date){
      if(!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    checkOut: function(date){
      if(!date) return '';
      return moment(date).add(1, 'days').format('DD/MM/YYYY');
    }
  },
  data: () => ({
    pagination: {
      bookings: [],
      pages: 1,
      total: 0,
      first: 0
    },
    property: {},
  }),
  created(){

    const propSlug = this.$route.params.property;
    this.property = this.$store.state.host.properties.find(p => p.slug == propSlug);

    this.loadBookings();
  },
  methods: {
    dayDiff: function(start, end){
      return moment(end).add(1, 'days').diff(moment(start), 'days');
    },
    loadBookings: function(){

      let url = '/bookings?propertyId=' + this.property._id;

      const page = this.$route.query.page || 1;
      const roomSlug = this.$route.params.room;

      if(roomSlug){
        url += '&roomSlug=' + roomSlug;
      }

      const checkInStart = this.$route.query.checkInStart;
      if(checkInStart){
        url += '&checkInStart=' + checkInStart;
      }

      const checkInEnd = this.$route.query.checkInEnd;
      if(checkInEnd){
        url += '&checkInEnd=' + checkInEnd;
      }

      const checkOutStart = this.$route.query.checkOutStart;
      if(checkOutStart){
        url += '&checkOutStart=' + checkOutStart;
      }

      const checkOutEnd = this.$route.query.checkOutEnd;
      if(checkOutEnd){
        url += '&checkOutEnd=' + checkOutEnd;
      }

      const search= this.$route.query.search;
      if(search){
        url += '&search=' + search;
      }

      fetch(process.env.VUE_APP_API + url + '&limit=20&skip=' + ((page - 1) * 20), {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        console.log(result);
        if(!result.error){
          return this.pagination = result;
        }
      })
    }
  }
};
</script>

<i18n>
{
  "en": {
    "bookings": "bookings",
    "name": "Name",
    "checkIn": "Check In",
    "checkOut": "Check Out",
    "nights": "Nights",
    "room": "Room",
    "unit": "Unit",
    "guests": "Guests",
    "referer": "Referer",
    "status": "Status",
    "created": "Created",
    "showing": "Showing",
    "to": "to",
    "of": "of",
    "entries": "entries"
  },
  "sl": {
    "bookings": "rezervacije",
    "name": "Ime in priimek",
    "checkIn": "Prihod",
    "checkOut": "Odhod",
    "nights": "Nočitve",
    "room": "Soba",
    "unit": "Enota",
    "guests": "Gostje",
    "referer": "Kanal",
    "status": "Status",
    "created": "Ustvarjeno",
    "showing": "Prikazanih",
    "to": "do",
    "of": "od",
    "entries": "vnosov"
  }
}
</i18n>
